<div class="container mt-4">
  <h2>Application Configurations</h2>

  <div class="alert alert-info my-3" role="alert">
    Kindly use this interface to manage application-wide settings. You can add,
    edit, and view configurations that affect the behavior of the application.
  </div>

  <button class="btn btn-success py-1 mb-3" (click)="showFormForNew()">
    + Add New Configuration
  </button>

  <!-- Form -->
  <div *ngIf="formVisible" class="card card-body mb-4">
    <form [formGroup]="configForm" (ngSubmit)="onSubmit()" class="mb-4">
      <div class="mb-3">
        <label for="configKey" class="form-label">Config Key</label>
        <input
          type="text"
          id="configKey"
          class="form-control"
          formControlName="configKey"
          [readonly]="editMode"
        />
      </div>

      <div class="mb-3">
        <label for="configValue" class="form-label">Config Value</label>
        <input
          type="text"
          id="configValue"
          class="form-control"
          formControlName="configValue"
        />
      </div>

      <div class="mb-3">
        <label for="description" class="form-label">Description</label>
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
        ></textarea>
      </div>

      <button type="submit" class="btn btn-primary me-2">
        {{ editMode ? "Update" : "Add" }} Config
      </button>
      <button type="button" class="btn btn-secondary" (click)="resetForm()">
        Cancel
      </button>
    </form>
  </div>

  <!-- List -->
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>ID</th>
        <th>Config Key</th>
        <th>Config Value</th>
        <th>Description</th>
        <!-- 
        <th>Created At</th>
        <th>Updated At</th> 
        -->
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let config of configs">
        <td>{{ config.id }}</td>
        <td>{{ config.configKey }}</td>
        <td>{{ config.configValue }}</td>
        <td>{{ config.description }}</td>
        <!-- 
        <td>{{ config.createdAt | date : "short" }}</td>
        <td>{{ config.updatedAt | date : "short" }}</td> 
        -->
        <td>
          <button
            class="btn btn-sm btn-warning me-2"
            (click)="editConfig(config)"
          >
            Edit
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
